import { useEffect, useRef, useState } from 'react'
import Header from 'components/Header/Header'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './style.css'
import { List, portfolio, portfolioRaw } from 'data/portfolio'
import useIntersectionObserver from 'hook/useIntersectionObserver'
import First from 'components/Portfolio/Fisrt'
import Second from 'components/Portfolio/Second'
import PortfolioSwiper from 'components/Common/PortfolioSwiper/PortfolioSwiper'

const PortfolioDetail = () => {
  const navigate = useNavigate()
  const [isWhite, setIsWhite] = useState(false);
  const [searchParams] = useSearchParams();
  const portfolioID = searchParams.get("id"); // id 값을 가져옴
  const [data, setData] = useState<List>({
    id: 0,
    logo: '',
    background: '',
    detail: '',
    name: '',
    period: '',
    description: '',
    type: '',
    descriptionEn: '',
    keyPoint: '',
    keyPointImg: '',
    architecture: '',
    wireFrame: '',
  })

  const firstRef = useRef<any>(null);

  useEffect(() => {
    if (portfolioID) {
      if (portfolioRaw.find(arr => arr.id === Number(portfolioID))) {
        init(portfolioID);
      }
      else {
        navigate(-1)
      }
    }
    else {
      navigate(-1)
    }
  }, [portfolioID, navigate])

  useEffect(() => {
    window.scrollTo(0, 0)
    firstRef.current = document.getElementById('change') as HTMLElement;
  }, [])

  useIntersectionObserver({
    target: firstRef,
    threshold: 0.1,
    enabled: true,
    onIntersect: () => setIsWhite(true),
    offIntersect: () => setIsWhite(false),
  });

  const init = (portfolioID: string) => {
    const filteredData = portfolio.flatMap((group) =>
      group.data.filter((item) => item.id === Number(portfolioID))
    );
    if (filteredData[0]) {
      setData(filteredData[0])
    }
  }

  const Content = ({ selectedData }: { selectedData: List }) => {
    const ContentComponent = selectedData.content;
    return ContentComponent ? <ContentComponent /> : <></>
  };

  return (
    <>
      <Header bgWhite={!isWhite} isWhite={false} isOverLay={!isWhite} />
      <First data={data} />
      <Second data={data} />
      <Content selectedData={data} />

      <div className='pb-24 tablet:pb-8 container'>
        <PortfolioSwiper init={init} />
      </div>
    </>
  )
}

export default PortfolioDetail